var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#73AF00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2487 24.1673H17.7487C22.332 24.1673 24.1654 22.334 24.1654 17.7507V12.2507C24.1654 7.66732 22.332 5.83398 17.7487 5.83398H12.2487C7.66536 5.83398 5.83203 7.66732 5.83203 12.2507V17.7507C5.83203 22.334 7.66536 24.1673 12.2487 24.1673Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2513 13.1667C13.2638 13.1667 14.0846 12.3459 14.0846 11.3333C14.0846 10.3208 13.2638 9.5 12.2513 9.5C11.2388 9.5 10.418 10.3208 10.418 11.3333C10.418 12.3459 11.2388 13.1667 12.2513 13.1667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.44922 21.3712L10.9684 18.337C11.6926 17.8512 12.7376 17.9062 13.3884 18.4653L13.6909 18.7312C14.4059 19.3453 15.5609 19.3453 16.2759 18.7312L20.0892 15.4587C20.8042 14.8445 21.9592 14.8445 22.6742 15.4587L24.1684 16.742",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgGreen);
export default __webpack_public_path__ + "static/media/img-green.7158c91598a9d9d8c39b1253f24520f9.svg";
export { ForwardRef as ReactComponent };